import m from "../../../../geodata/es2015/region/usa/riLow";
window.am4geodata_region_usa_riLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/riLow.js
// module id = null
// module chunks = 